import React, { Fragment, useEffect, useMemo, useState } from 'react'
import { Dashboard } from '../../../components/ExportImgFigma'
import { DatePicker, Tabs } from 'antd'
import '../styles.scss'

import ReactECharts from "echarts-for-react";
import { TabsProps } from 'antd/lib'
import ServiceMaintenanceInvoice from './ServiceMaintenanceInvoice'
import VehicleInvoice from './VehicleInvoice'
import { formatNumber } from '../../../services/mixin';
import dayjs from "dayjs";
import { SHOW_KEYNAME } from '../../../env';

const InvoiceHistory = ({ stData = {} as any, stChange = (data: any) => { }, defaultSubTab = undefined as string | undefined }) => {
  // tính dữ liệu cho chart
  const [year, setYear] = useState<number>(2025);

  const buyData = useMemo(() => {
    const arr = Array(12).fill(0);
    (stData.vehicle_invoice_dates || []).forEach((val: any) => {
      if (!val.contract_date) return;
      const [day, monthx, yearx] = val.contract_date.split('/');
      const formattedDate = `${yearx}-${monthx}-${day}`;
      const month = new Date(formattedDate).getMonth();
      if (year !== Number(yearx)) return;
      arr[month] += 1;
    });
    return arr;
  }, [stData.vehicle_invoice_dates, year]);

  const serviceData = useMemo(() => {
    const arr = Array(12).fill(0);
    (stData.service_invoice_dates || []).forEach((val: any) => {
      if (!val.invoice_service_doc_date) return;
      const [day, monthx, yearx] = val.invoice_service_doc_date.split('/');
      const formattedDate = `${yearx}-${monthx}-${day}`;
      const month = new Date(formattedDate).getMonth();
      if (year !== Number(yearx)) return;
      arr[month] += 1;
    });
    return arr;
  }, [stData.service_invoice_dates, year]);

  // chart
  const option = useMemo(() => ({
    title: '',
    tooltip: { trigger: "axis" },
    xAxis: { type: "category", data: ["Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6", "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"] },
    yAxis: {
      type: "value", axisLabel: {
        formatter: function (value: any) {
          return value < 1 ? '' : value;
        }
      }
    },
    series: [
      {
        name: "Hóa đơn mua xe",
        type: "bar",
        stack: "total",
        data: buyData,
        itemStyle: {
          color: {
            type: "linear", x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: "#3b82f6" },
              { offset: 1, color: "#93c5fd" }
            ]
          }
        }
      },
    ]
  }), [buyData, serviceData]);
  const option2 = useMemo(() => ({
    title: '',
    tooltip: { trigger: "axis" },
    xAxis: { type: "category", data: ["Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6", "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"] },
    yAxis: {
      type: "value", axisLabel: {
        formatter: function (value: any) {
          return value < 1 ? '' : value;
        }
      }
    },
    series: [
      {
        name: "Hóa đơn dịch vụ",
        type: "bar",
        stack: "total",
        data: serviceData,
        itemStyle: {
          color: {
            type: "linear", x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: "#f87171" },
              { offset: 1, color: "#fecaca" }
            ]
          }
        }
      }
    ]
  }), [buyData, serviceData]);

  const handleChangeYear = (date: any) => {
    if (date) setYear(date.year());
  };

  const [isTab, setIsTab] = useState(defaultSubTab || '1');
  const onChange = (key: string) => {
    setIsTab(key);
  };

  // useEffect(() => {
  //   const ftList = [
  //     'vehicle_invoice_sale_params_chassis_no',
  //     'service_invoice_service_params_chassis_no',
  //     'vehicle_invoice_sale_params_branch_name',
  //     'service_invoice_service_params_branch_name',
  //   ]
  //   setTimeout(() => {
  //     ftList.forEach(ft => {
  //       const el = document.getElementById(ft) as any;
  //       if (!el) return;
  //       if (stData[ft]) {
  //         el.classList.add('active');
  //       } else {
  //         el.classList.remove('active');
  //       }
  //     });
  //   }, 200);
  // }, [isTab]);

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: <span className='custom-page-css font-light text-lg'>Hoá đơn xe</span>,
      children: <VehicleInvoice stData={stData} stChange={(data) => stChange(data)} />,
    },
    {
      key: '2',
      label: <span className='custom-page-css font-light text-lg'>Hoá đơn bảo trì dịch vụ</span>,
      children: <ServiceMaintenanceInvoice stData={stData} stChange={(data) => stChange(data)} />,
    },
  ];

  return (
    <Fragment>
      <div className='custom-page-css w-full pb-3 flex flex-col gap-3'>
        <div className="custom-page-css w-full flex gap-3">
          <div className="custom-page-css  flex flex-2 flex-col justify-around rounded border">
            <div className="custom-page-css w-full flex items-center justify-around gap-4 p-3 border-b">
              <div className="custom-page-css flex items-center justify-center gap-3">
                <div className="custom-page-css flex items-center justify-center p-1 bg-E6F7FF rounded-full ">
                  <img src={Dashboard} alt="" style={{ height: 16, width: 16, objectFit: 'contain' }} />
                </div>
                <span className='custom-page-css text-xl font-light text-475467'>Tổng chi tiêu</span>
              </div>
              <span className='custom-page-css text-2xl font-light font-medium px-1 text-344054' {...(SHOW_KEYNAME === true && { 'col-id': 'total_info_summary.total_spending.total' })}>{formatNumber(stData.total_info_summary?.total_spending.total)}</span>

            </div>
            <div className="custom-page-css px-2 flex flex-col justify-around">
              <div className="custom-page-css flex py-2 flex-1 border-b">
                <div className="custom-page-css py-2 flex flex-1 flex-col items-center justify-center gap-1 border-r">
                  <span className='custom-page-css text-2xl font-light font-medium px-1 text-344054' {...(SHOW_KEYNAME === true && { 'col-id': 'total_vehicle_invoices' })}>{stData.total_vehicle_invoices}</span>
                  <span className='custom-page-css text-xl font-light text-475467 text-center'>SL hóa đơn mua xe </span>
                </div>
                <div className="custom-page-css py-2 flex flex-1 flex-col items-center justify-center gap-1 ">
                  <span className='custom-page-css text-2xl font-light font-medium px-1 text-344054' {...(SHOW_KEYNAME === true && { 'col-id': 'total_service_invoices' })}>{stData.total_service_invoices}</span>
                  <span className='custom-page-css text-xl font-light text-475467 text-center'>SL hóa đơn dịch vụ</span>
                </div>
              </div>
              <div className="custom-page-css flex py-2 flex-1 ">
                <div className="custom-page-css py-2 flex flex-1 flex-col items-center justify-center gap-1 border-r">
                  <span className='custom-page-css text-2xl font-light font-medium px-1 text-344054' {...(SHOW_KEYNAME === true && { 'col-id': 'total_vehicle_amount' })}>{formatNumber(stData.total_vehicle_amount)}</span>
                  <span className='custom-page-css text-xl font-light text-475467 text-center'>Hóa đơn mua xe </span>
                </div>
                <div className="custom-page-css py-2 flex flex-1 flex-col items-center justify-center gap-1 ">
                  <span className='custom-page-css text-2xl font-light font-medium px-1 text-344054' {...(SHOW_KEYNAME === true && { 'col-id': 'total_service_amount' })}>{formatNumber(stData.total_service_amount)}</span>
                  <span className='custom-page-css text-xl font-light text-475467 text-center'>Hóa đơn dịch vụ</span>
                </div>
              </div>
            </div>
          </div>
          <div className="custom-page-css  flex flex-5 flex-col rounded border">
            <div style={{ border: "1px solid #e5e7eb", borderRadius: 8, padding: 16 }}>
              {/* Title + DatePicker cùng hàng */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                <span className='custom-page-css font-bold  text-xl text-344054'>
                  Thống kê số lượng hóa đơn giao dịch trong năm
                </span>
                <DatePicker
                  picker="year"
                  onChange={handleChangeYear}
                  defaultValue={dayjs(`${year}`, "YYYY")}
                />
              </div>

              {/* Chart */}
              {isTab === '1' ?
                <ReactECharts option={option} />
                :
                <ReactECharts option={option2} />
              }
              <div className='ctr-chart'>
                <div className={`item-ctr y1 ${isTab === '1' ? 'active' : ''}`} onClick={() => setIsTab('1')}>
                  <div className='color'></div>
                  <span className='text'>Hóa đơn mua xe</span>
                </div>
                <div className={`item-ctr y2 ${isTab === '2' ? 'active' : ''}`} onClick={() => setIsTab('2')}>
                  <div className='color'></div>
                  <span className='text'>Hóa đơn dịch vụ</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="custom-page-css w-full flex items-center justify-between gap-3 pt-3">
          <Tabs activeKey={isTab} items={items} onChange={onChange} className='w-full' />
        </div>
      </div>
    </Fragment>
  )
}
export default InvoiceHistory
